import { Controller } from "@hotwired/stimulus"

// Fills the Placement key from its name as snake_case, until the key is
// edited by hand. Each fill is announced as input, so the live key check runs.
export default class extends Controller {
  static targets = [ "name", "key" ]

  connect() {
    const key = this.keyTarget.value
    this.handEdited = key !== "" && key !== this.snakeCase(this.nameTarget.value)
  }

  fill() {
    if (this.handEdited) return

    this.keyTarget.value = this.snakeCase(this.nameTarget.value)
    this.filling = true
    this.keyTarget.dispatchEvent(new Event("input", { bubbles: true }))
    this.filling = false
  }

  keyEdited() {
    if (!this.filling) this.handEdited = true
  }

  snakeCase(text) {
    return text.toLowerCase().normalize("NFKD").replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "")
  }
}
